import { defineComponent as _defineComponent } from 'vue'
import { useBilling } from '@/components/Billing/Billing.composables';
import { ProductType, Product } from '@/components/Billing/billing-types';
// @ts-ignore
import BillingFeaturesSection from '@/components/Billing/BillingFeaturesSection.vue';
// @ts-ignore
import CustomerFeaturesSectionHeader from '@/components/Billing/CustomerFeatures/CustomerFeaturesSectionHeader.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingCustomerFeatures',
  props: {
    selectedCustomerFeatureProduct: null,
    currentAccountCustomerFeatureProduct: null,
    currentAccountCustomerFeatureQuantity: null
  },
  emits: ["select-plan", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select-plan', planId: string): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {



const { customerPlans } = useBilling();
const productType = ProductType.CustomerFeatures;

return { __sfc: true,emit, customerPlans, productType, BillingFeaturesSection, CustomerFeaturesSectionHeader }
}

})